import { toast } from 'react-toastify';
import {
  ColumnHeaderType,
  CreateLeadLocationDataType,
  EmployeeNameType,
  LeadDetailsType,
  LoggedUserType,
  UserType,
  ViewLeadsFilterType,
} from '../../utils/Types';
import moment from 'moment';
import {
  assignLeadToOther,
  creteNewLead,
  fetchLeadDetails,
  updateLeadStatusDetails,
} from '../../features/leadSlice';
import { API_RESPONSE_CODE, CLICK_ACTIONS } from '../../utils/Constant';
import { ThunkDispatch } from 'redux-thunk';
import { saveCommentNote } from '../../features/onboardingSlice';
import { blankValueGetter, isAPIFailed, isAPISuccess } from '../../utils/Util';
import { STATE_ACCESS_ROLES } from '../../utils/RBAC';

// this is the validation u need to change leadType,lead name,leadnumber
export const checkValidation = (
  leadDetails: any,
  lobName: any,
  locationData: CreateLeadLocationDataType,
  selectedLeadTypeId?: number,
  rmName?: any,
  rmMobileNum?: any,
  selectedBank?: any,
  selectedBranch?: any,
  leadListPayload?: any
): boolean => {
  let isValid = true;
  const allZerosRegex = /^0+$/;
  const TEXT_ONLY_REGEX = /^[a-zA-Z\s]*$/;
  const isValidName = (name: any) => {
    return (
      TEXT_ONLY_REGEX.test(name) &&
      name.trim().length >= 2 &&
      name.trim().length <= 50
    );
  };
  const numberRegex = /^[+]?(91)?[6789]\d{9}$/;

  if (!selectedLeadTypeId) {
    toast.error('Lead type can not be blank.');
    isValid = false;
  } else if (!lobName) {
    toast.error('LOB type can not be blank.');
    isValid = false;
  } else if (
    selectedLeadTypeId != 3 &&
    selectedLeadTypeId != 4 &&
    selectedLeadTypeId != 5 &&
    selectedLeadTypeId != 6 &&
    selectedLeadTypeId != 7 &&
    selectedLeadTypeId != 8 &&
    (!leadDetails?.name || !isValidName(leadDetails?.name))
  ) {
    toast.error('Enter valid lead Name');
    isValid = false;
  } else if (
    (selectedLeadTypeId == 3 ||
      selectedLeadTypeId == 4 ||
      selectedLeadTypeId == 5 ||
      selectedLeadTypeId == 6 ||
      selectedLeadTypeId == 7 ||
      selectedLeadTypeId == 8) &&
    leadListPayload?.length == 0
  ) {
    toast.error('Please provide atleast one lead details');
    isValid = false;
  } else if (selectedLeadTypeId == 3 && rmName && !isValidName(rmName)) {
    toast.error('Enter valid Branch Manager Name');
    isValid = false;
  } else if (
    selectedLeadTypeId != 3 &&
    selectedLeadTypeId != 4 &&
    selectedLeadTypeId != 5 &&
    selectedLeadTypeId != 6 &&
    selectedLeadTypeId != 7 &&
    selectedLeadTypeId != 8 &&
    !numberRegex.test(leadDetails?.contactNumber)
  ) {
    toast.error('Enter valid contact Number');
    isValid = false;
  } else if (
    selectedLeadTypeId == 3 &&
    rmMobileNum &&
    !numberRegex.test(rmMobileNum)
  ) {
    toast.error('Enter valid Branch Manager contact Number');
    isValid = false;
  } else if (
    selectedLeadTypeId != 3 &&
    selectedLeadTypeId != 4 &&
    selectedLeadTypeId != 5 &&
    selectedLeadTypeId != 6 &&
    selectedLeadTypeId != 7 &&
    selectedLeadTypeId != 8 &&
    allZerosRegex.test(leadDetails?.contactNumber)
  ) {
    toast.error('Contact number cannot consist of all zeros.');
    isValid = false;
  } else if (
    selectedLeadTypeId == 3 &&
    rmMobileNum &&
    allZerosRegex.test(rmMobileNum)
  ) {
    toast.error('Branch Manager Contact number cannot consist of all zeros.');
    isValid = false;
  } else if (
    selectedLeadTypeId != 3 &&
    selectedLeadTypeId != 4 &&
    selectedLeadTypeId != 5 &&
    selectedLeadTypeId != 6 &&
    selectedLeadTypeId != 7 &&
    selectedLeadTypeId != 8 &&
    leadDetails?.contactNumber.length !== 10
  ) {
    toast.info('Contact Number must be 10 digits.');
    isValid = false;
  } else if (
    selectedLeadTypeId == 3 &&
    rmMobileNum &&
    rmMobileNum.length !== 10
  ) {
    toast.info('Branch Manger Contact Number must be 10 digits.');
    isValid = false;
  } else if (
    selectedLeadTypeId != 3 &&
    selectedLeadTypeId != 4 &&
    selectedLeadTypeId != 5 &&
    selectedLeadTypeId != 6 &&
    selectedLeadTypeId != 7 &&
    selectedLeadTypeId != 8 &&
    !/^\d+$/.test(leadDetails?.contactNumber)
  ) {
    toast.error('Contact Number should only contain digits');
    isValid = false;
  } else if (
    selectedLeadTypeId == 3 &&
    rmMobileNum &&
    !/^\d+$/.test(rmMobileNum)
  ) {
    toast.error('Branch Manger Contact Number should only contain digits');
    isValid = false;
  } else if (
    selectedLeadTypeId != 3 &&
    selectedLeadTypeId != 4 &&
    selectedLeadTypeId != 5 &&
    selectedLeadTypeId != 6 &&
    selectedLeadTypeId != 7 &&
    selectedLeadTypeId != 8 &&
    !locationData?.pincode
  ) {
    toast.error('Pincode can not be empty.');
    isValid = false;
  } else if (
    selectedLeadTypeId != 3 &&
    selectedLeadTypeId != 4 &&
    selectedLeadTypeId != 5 &&
    selectedLeadTypeId != 6 &&
    selectedLeadTypeId != 7 &&
    selectedLeadTypeId != 8 &&
    !locationData?.zone
  ) {
    toast.info('Zone name can not be empty');
    isValid = false;
  } else if (
    selectedLeadTypeId != 3 &&
    selectedLeadTypeId != 4 &&
    selectedLeadTypeId != 5 &&
    selectedLeadTypeId != 6 &&
    selectedLeadTypeId != 7 &&
    selectedLeadTypeId != 8 &&
    !locationData?.state
  ) {
    toast.info('State name can not be empty');
    isValid = false;
  } else if (
    selectedLeadTypeId != 3 &&
    selectedLeadTypeId != 4 &&
    selectedLeadTypeId != 5 &&
    selectedLeadTypeId != 6 &&
    selectedLeadTypeId != 7 &&
    selectedLeadTypeId != 8 &&
    !locationData?.district
  ) {
    toast.info('District name can not be empty');
    isValid = false;
  } else if (
    selectedLeadTypeId != 3 &&
    selectedLeadTypeId != 4 &&
    selectedLeadTypeId != 5 &&
    selectedLeadTypeId != 6 &&
    selectedLeadTypeId != 7 &&
    selectedLeadTypeId != 8 &&
    !locationData?.city
  ) {
    toast.info('Village name can not be empty');
    isValid = false;
  } else if (selectedLeadTypeId == 3 && !selectedBank) {
    toast.info('Bank name can not be empty');
    isValid = false;
  } else if (selectedLeadTypeId == 3 && !selectedBranch) {
    toast.info('Branch name can not be empty');
    isValid = false;
  } else if (
    (selectedLeadTypeId == 3 ||
      selectedLeadTypeId == 4 ||
      selectedLeadTypeId == 5 ||
      selectedLeadTypeId == 6 ||
      selectedLeadTypeId == 7 ||
      selectedLeadTypeId == 8) &&
    leadListPayload?.length > 500
  ) {
    toast.error('Minimum Leads per single submit is 500');
    isValid = false;
  }
  return isValid;
};

export const getReqParam = (
  leadDetails: any,
  lobName: any,
  locationData: CreateLeadLocationDataType,
  completionDateTime: string,
  selectedEmployee: EmployeeNameType,
  selectedLeadTypeId?: number,
  comment?: string,
  rmName?: any,
  rmMobileNum?: any,
  selectedBank?: any,
  selectedBranch?: any,
  leadListPayload?: any
) => {
  const data = {
    leadType: selectedLeadTypeId,
    lobId: lobName,
    lead:
      selectedLeadTypeId == 3 ||
      selectedLeadTypeId == 4 ||
      selectedLeadTypeId == 5 ||
      selectedLeadTypeId == 6 ||
      selectedLeadTypeId == 7 ||
      selectedLeadTypeId == 8
        ? leadListPayload
        : [
            {
              leadName: leadDetails.name,
              leadNumber: leadDetails.contactNumber,
              state: Number(locationData.state),
              district: Number(locationData.district),
              city: Number(locationData.city),
              zone: Number(locationData.zone),
              pincode: locationData.pincode,
            },
          ],
    assignedToId: selectedEmployee?.candidateId || null, // use || instead of ?? that make assignedToId null
    comments: comment ?? '',
    leadReceivedOn: completionDateTime
      ? new Date(
          moment(completionDateTime, 'DD-MM-YYYY H:mm').format(
            'DD MMM YYYY H:mm'
          )
        ).toISOString()
      : new Date().toISOString(),
    bankId: selectedBank,
    branchId: selectedBranch,
    rmName: rmName,
    rmMobileNum: rmMobileNum,
  };
  return data;
};

export const findSelectedLeadDetails = (
  setShowLoader: (value: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>,
  handleLeadsData: (value: LeadDetailsType) => void,
  setLeadToViewDetails: (value: LeadDetailsType) => void,
  leadId: string
) => {
  setShowLoader(true);
  try {
    dispatch(fetchLeadDetails({ leadId }))
      .then((fulfilled: any) => {
        if (
          fulfilled?.payload.responseInformation &&
          fulfilled?.payload.responseInformation.responseCode ===
            API_RESPONSE_CODE.SUCCESS
        ) {
          const lead: any = fulfilled?.payload.result;
          setLeadToViewDetails(lead);
          handleLeadsData(lead);
        }
        setShowLoader(false);
      })
      .catch(() => {
        setShowLoader(false);
      });
  } catch (e) {}
};
export const assignTask = (
  data: {
    leadId: string;
    assignedToId: number | string | null;
  },
  setShowLoader: (value: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>,
  handleLeadsData: (value: LeadDetailsType) => void,
  setLeadToViewDetails: (value: LeadDetailsType) => void
) => {
  setShowLoader(true);
  dispatch(assignLeadToOther(data))
    .then((fulfilled: any) => {
      if (
        fulfilled?.payload.responseInformation &&
        fulfilled?.payload.responseInformation.responseCode ===
          API_RESPONSE_CODE.FAIL
      ) {
        toast.error(fulfilled?.payload.responseInformation.responseMessage);
      } else if (
        fulfilled?.payload.responseInformation &&
        fulfilled?.payload.responseInformation.responseCode ===
          API_RESPONSE_CODE.SUCCESS
      ) {
        findSelectedLeadDetails(
          setShowLoader,
          dispatch,
          handleLeadsData,
          setLeadToViewDetails,
          data.leadId
        );
        toast.success(fulfilled?.payload.responseInformation.responseMessage);
      }
      setShowLoader(false);
    })
    .catch(() => {
      setShowLoader(false);
    });
};

export const updateLeadStatus = (
  data: {
    leadId: string;
    comments: string;
    leadStatus?: number;
  },
  leadToViewDetails: LeadDetailsType | undefined,
  optionTaskStatus: number | undefined,
  setShowLoader: (value: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>,
  handleLeadsData: (value: LeadDetailsType) => void,
  setLeadToViewDetails: (value: LeadDetailsType) => void
) => {
  setShowLoader(true);
  dispatch(updateLeadStatusDetails(data))
    .then((fulfilled: any) => {
      const payload = fulfilled?.payload;
      if (payload?.responseCode === API_RESPONSE_CODE.FAIL) {
        toast.error(payload?.responseMessage);
      } else if (payload?.responseCode === API_RESPONSE_CODE.SUCCESS) {
        toast.success(payload?.responseMessage);
        const updateLead: any = {
          ...leadToViewDetails,
          leadStatus: optionTaskStatus,
        };
        setLeadToViewDetails(updateLead);
        if (leadToViewDetails?.leadId) {
          findSelectedLeadDetails(
            setShowLoader,
            dispatch,
            handleLeadsData,
            setLeadToViewDetails,
            leadToViewDetails?.leadId
          );
        }
      }
      setShowLoader(false);
    })
    .catch(() => {
      setShowLoader(false);
    });
};

export const saveComment = (
  param: {
    comment: string;
    leadUniqueId: string;
    leadToViewDetails?: LeadDetailsType;
  },
  setShowLoader: (value: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>,
  setLeadToViewDetails: (value: LeadDetailsType) => void,
  handleLeadsData: (value?: LeadDetailsType) => void,
  setComment: (value: string) => void
) => {
  if (param.comment && param.leadToViewDetails) {
    const data = {
      notesDescription: param.comment,
      module: 3, // 1 - REGISTRATION, 2 - TASK_ASSIGNMENT, 3 - LEAD_ASSIGNMENT
      referenceId: param.leadToViewDetails?.leadGenerationId, // for LEAD_ASSIGNMENT : leadGenerationId
    };
    setShowLoader(true);
    dispatch(saveCommentNote(data))
      .then((fulfilled: any) => {
        const payload = fulfilled?.payload;
        if (isAPIFailed(payload)) {
          toast.error(payload?.responseInformation.responseMessage);
        } else if (isAPISuccess(fulfilled)) {
          toast.success(payload?.responseInformation.responseMessage);
        }
        setShowLoader(false);
        if (!param.leadUniqueId) {
          handleLeadsData();
        } else {
          findSelectedLeadDetails(
            setShowLoader,
            dispatch,
            handleLeadsData,
            setLeadToViewDetails,
            param.leadUniqueId
          );
        }
      })
      .catch(() => {
        toast.error('Comment add failed!');
        setShowLoader(false);
      });
    setComment('');
  }
};
export const createLead = (
  data: {
    leadDetails: any;
    lobName: any;
    completionDateTime: string;
    selectedEmployee: EmployeeNameType;
    selectedLeadTypeId: number | undefined;
    locationData: CreateLeadLocationDataType;
    comment: string | undefined;
    rmName: any;
    rmMobileNum: any;
    selectedBank: any;
    selectedBranch: any;
    leadListPayload: any;
  },
  setShowLoader: (value: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>,
  clearFields: () => void
) => {
  if (
    !checkValidation(
      data.leadDetails,
      data.lobName,
      data.locationData,
      data.selectedLeadTypeId,
      data.rmName,
      data.rmMobileNum,
      data.selectedBank,
      data.selectedBranch,
      data.leadListPayload
    )
  ) {
    return;
  }
  setShowLoader(true);
  dispatch(
    creteNewLead(
      getReqParam(
        data.leadDetails,
        data.lobName,
        data.locationData,
        data.completionDateTime,
        data.selectedEmployee,
        data.selectedLeadTypeId,
        data.comment,
        data.rmName,
        data.rmMobileNum,
        data.selectedBank,
        data.selectedBranch,
        data.leadListPayload
      )
    )
  )
    ?.then((fulfilled: any) => {
      if (isAPIFailed(fulfilled?.payload)) {
        toast.error(fulfilled?.payload.responseInformation.responseMessage);
      } else if (isAPISuccess(fulfilled?.payload)) {
        toast.success(fulfilled?.payload.responseInformation.responseMessage);
        clearFields();
      }
      setShowLoader(false);
    })
    ?.catch(() => {
      setShowLoader(false);
    });
};

export const addFilterToData = (data: any, filter: ViewLeadsFilterType) => {
  if (filter?.leadId) data.leadId = filter.leadId;
  if (filter?.leadType?.value) data.leadType = filter.leadType.value;
  if (filter?.assignedTo?.value) data.assignedToId = filter.assignedTo.value;
  if (filter?.status?.value) data.status = filter.status.value;
  if (filter.fromDate)
    data.fromDate = moment(filter?.fromDate).format('YYYY-MM-DD');
  if (filter.toDate) data.toDate = moment(filter?.toDate).format('YYYY-MM-DD');
  if (filter.pincode) data.pincode = filter.pincode;
  if (filter?.state?.value) data.state = Number(filter.state.value);
  if (filter?.district?.value) data.district = Number(filter.district.value);
  if (filter?.zone?.value) data.zone = Number(filter.zone.value);
  if (filter?.city?.value) data.location = Number(filter.city.value);
};

export const getViewLeadRequest = (
  currentPage: number,
  pageSize: number,
  user: LoggedUserType,
  userDetails: UserType,
  filter?: ViewLeadsFilterType
) => {
  const data: any = {
    pageNumber: currentPage,
    pagePerCount: pageSize,
  };
  if (
    STATE_ACCESS_ROLES.includes(user?.roleId) &&
    userDetails?.reportingZones?.length
  ) {
    data.zone = Number(userDetails.reportingZones[0]);
  }
  if (filter) {
    addFilterToData(data, filter);
  }

  return data;
};

export const VIEW_LEADDETAILS_HEADER: ColumnHeaderType[] = [
  {
    name: 'Lead Name',
    field: 'name',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Contact Number',
    field: 'contactNumber',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Product',
    field: 'productId',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Crop',
    field: 'cropName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Loan Amount',
    field: 'loanAmount',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Zone',
    field: 'zoneName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'State',
    field: 'stateName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'District',
    field: 'districtName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Village',
    field: 'villageName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Pincode',
    field: 'pincode',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Remove',
    field: 'remove',
    sortable: false,
    clickable: true,
    action: CLICK_ACTIONS.DELETE,
  },
];

export const VIEW_LEADMOTORDETAILS_HEADER: ColumnHeaderType[] = [
  {
    name: 'Lead First Name',
    field: 'firstname',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Lead Last Name',
    field: 'lastname',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Contact Number',
    field: 'contactNumber',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Alternate Contact Number',
    field: 'alternateContactNumber',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Risk Coverage',
    field: 'riskCoverageName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Vehicle Type',
    field: 'vehicleTypeName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Make',
    field: 'make',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Zone',
    field: 'zoneName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'State',
    field: 'stateName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'District',
    field: 'districtName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Village',
    field: 'villageName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Pincode',
    field: 'pincode',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Owner Name as per RC',
    field: 'OwnerNameASPerRC',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Vehicle Regn No',
    field: 'VehicleRegnNo',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Aadhar Number',
    field: 'AadharNumber',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Date of Birth',
    field: 'date',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Time Frame of Purchase',
    field: 'timeframeOfPurchase',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Ever Insured',
    field: 'everInsured',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Additional Information',
    field: 'additionalInformation',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Remove',
    field: 'remove',
    sortable: false,
    clickable: true,
    action: CLICK_ACTIONS.DELETE,
  },
];

export const VIEW_LEADOTHERDETAILS_HEADER: ColumnHeaderType[] = [
  {
    name: 'Lead First Name',
    field: 'firstname',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Lead Last Name',
    field: 'lastname',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Contact Number',
    field: 'contactNumber',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Alternate Contact Number',
    field: 'alternateContactNumber',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Interested In',
    field: 'intrestedForName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Zone',
    field: 'zoneName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'State',
    field: 'stateName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'District',
    field: 'districtName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Village',
    field: 'villageName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Pincode',
    field: 'pincode',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Aadhar Number',
    field: 'AadharNumber',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Date of Birth',
    field: 'date',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Time Frame of Purchase',
    field: 'timeframeOfPurchase',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Ever Insured',
    field: 'everInsured',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Additional Information',
    field: 'additionalInformation',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Remove',
    field: 'remove',
    sortable: false,
    clickable: true,
    action: CLICK_ACTIONS.DELETE,
  },
];

export const VIEW_LEADHEALTHDETAILS_HEADER: ColumnHeaderType[] = [
  {
    name: 'Lead First Name',
    field: 'firstname',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Lead Last Name',
    field: 'lastname',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Contact Number',
    field: 'contactNumber',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Alternate Contact Number',
    field: 'alternateContactNumber',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Type of cover',
    field: 'typeofCoverName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Coverage',
    field: 'coverageName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Coverage For',
    field: 'coverageForName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Zone',
    field: 'zoneName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'State',
    field: 'stateName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'District',
    field: 'districtName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Village',
    field: 'villageName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Pincode',
    field: 'pincode',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Aadhar number',
    field: 'AadharNumber',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Date of birth',
    field: 'date',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Time Frame of Purchase',
    field: 'timeframeOfPurchase',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Ever Insured',
    field: 'everInsured',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Additional Information',
    field: 'additionalInformation',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Remove',
    field: 'remove',
    sortable: false,
    clickable: true,
    action: CLICK_ACTIONS.DELETE,
  },
];

export const VIEW_LEADCROPDETAILS_HEADER: ColumnHeaderType[] = [
  {
    name: 'First Name',
    field: 'firstname',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Last Name',
    field: 'lastname',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Mobile Number',
    field: 'contactNumber',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Alternate Mobile Number',
    field: 'alternateContactNumber',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Loanee Status',
    field: 'loaneeStatus',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Bank Name',
    field: 'bankNameData',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Branch Name',
    field: 'branchNamedata',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Tenant Status',
    field: 'tenantStatus',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Survey Number',
    field: 'surveyNumber',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Sub Survey Number',
    field: 'subSurveyNumber',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Zone',
    field: 'zoneName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'State',
    field: 'stateName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'District',
    field: 'districtName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Village',
    field: 'villageName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Pincode',
    field: 'pincode',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Timeframe Of Purchase',
    field: 'timeframeOfPurchase',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Past Insurance',
    field: 'pastInsurance',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Insured Area',
    field: 'insuredArea',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Area Dec',
    field: 'areaDec',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Remove',
    field: 'remove',
    sortable: false,
    clickable: true,
    action: CLICK_ACTIONS.DELETE,
  },
];
